import React, { useState, useEffect, useRef } from "react";

export default function PinModal({ isOpen, onClose, onSuccess, correctPin }) {
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setPin("");
      setError("");
      setTimeout(() => {
        inputRef.current?.focus();
      }, 0);
    }
  }, [isOpen]);

  useEffect(() => {
    if (pin.length === 4) {
      if (pin === correctPin) {
        setPin("");
        setError("");
        onSuccess();
        onClose();
      } else {
        setError("Incorrect PIN");
        setPin("");
      }
    }
  }, [pin, correctPin, onSuccess, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 px-4 backdrop-blur-sm">
      <div className="relative w-full max-w-sm rounded-2xl bg-white p-6 shadow-xl">
        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-slate-400 transition hover:text-slate-700"
          aria-label="Close"
        >
          <i className="fas fa-times text-lg"></i>
        </button>

        <div className="text-center">
          <h2 className="text-lg font-semibold text-slate-800">
            Enter Access PIN
          </h2>
          <p className="mt-1 text-sm text-slate-500">
            Enter your 4-digit access code
          </p>
        </div>

        <div className="mt-6">
          <input
            ref={inputRef}
            type="password"
            value={pin}
            maxLength={4}
            autoFocus
            inputMode="numeric"
            className="absolute opacity-0 pointer-events-none"
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              setPin(value);
              setError("");
            }}
          />

          <div
            className="flex items-center justify-center gap-3"
            onClick={() => inputRef.current?.focus()}
          >
            {[0, 1, 2, 3].map((index) => {
              const hasValue = pin[index];
              return (
                <div
                  key={index}
                  className={`flex h-14 w-14 items-center justify-center rounded-2xl border text-xl font-bold transition ${
                    error
                      ? "border-red-300 bg-red-50 text-red-500"
                      : hasValue
                        ? "border-slate-900 bg-slate-900 text-white"
                        : "border-slate-200 bg-slate-50 text-slate-300"
                  }`}
                >
                  {hasValue ? "•" : ""}
                </div>
              );
            })}
          </div>

          {error && (
            <p className="mt-4 text-center text-sm font-medium text-red-500">
              {error}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}